var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:letter-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.172 5.172C2 6.343 2 8.229 2 12C2 15.771 2 17.657 3.172 18.828C4.343 20 6.229 20 10 20H14C17.771 20 19.657 20 20.828 18.828C22 17.657 22 15.771 22 12C22 8.229 22 6.343 20.828 5.172C19.657 4 17.771 4 14 4H10C6.229 4 4.343 4 3.172 5.172ZM18.576 7.52C18.7032 7.67279 18.7646 7.86985 18.7466 8.06787C18.7286 8.26589 18.6327 8.44866 18.48 8.576L16.284 10.406C15.397 11.146 14.679 11.744 14.044 12.152C13.384 12.577 12.741 12.845 12 12.845C11.259 12.845 10.616 12.576 9.955 12.152C9.321 11.744 8.603 11.145 7.716 10.407L5.52 8.577C5.3671 8.4497 5.27104 8.26687 5.25294 8.06874C5.23484 7.8706 5.2962 7.6734 5.4235 7.5205C5.5508 7.3676 5.73363 7.27154 5.93176 7.25344C6.1299 7.23534 6.3271 7.2967 6.48 7.424L8.64 9.223C9.573 10 10.22 10.538 10.768 10.89C11.297 11.23 11.656 11.345 12.001 11.345C12.346 11.345 12.705 11.231 13.234 10.89C13.781 10.538 14.429 10 15.362 9.223L17.521 7.423C17.6739 7.29587 17.8711 7.23467 18.0691 7.25286C18.2671 7.27105 18.4488 7.36714 18.576 7.52Z",
    fill: "#00A0FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.f44ff47c0ef29bbec9a5b4d016c8467c.svg";
export { ForwardRef as ReactComponent };